import { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ReportBuilder } from '../components/ReportBuilder'
import { patientService } from '../services/patientService'
import { Patient } from '../types/patient'
import './PatientReport.css'

export function PatientReport() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [showBuilder, setShowBuilder] = useState(false)

  const { data: patient, isLoading } = useQuery<Patient>({
    queryKey: ['patient', id],
    queryFn: () => patientService.getById(id!),
    enabled: !!id,
  })

  if (isLoading) {
    return (
      <div className="patient-report-page">
        <div className="loading">Loading patient...</div>
      </div>
    )
  }

  if (!patient) {
    return (
      <div className="patient-report-page">
        <div className="error">Patient not found</div>
      </div>
    )
  }

  return (
    <div className="patient-report-page">
      <div className="patient-report-header">
        <div>
          <h1>Patient Report</h1>
          <p className="patient-name">
            {patient.firstName} {patient.lastName}
            {patient.patientNumber && ` (${patient.patientNumber})`}
          </p>
        </div>
        <div className="header-actions">
          <button
            className="btn-secondary"
            onClick={() => navigate(`/patients/${id}`)}
          >
            Back to Patient
          </button>
          <button
            className="btn-primary"
            onClick={() => setShowBuilder(true)}
          >
            Generate Report
          </button>
        </div>
      </div>

      {showBuilder && (
        <div className="report-builder-container">
          <ReportBuilder
            patientId={id}
            onReportGenerated={() => setShowBuilder(false)}
            onCancel={() => setShowBuilder(false)}
          />
        </div>
      )}

      {!showBuilder && (
        <div className="report-info">
          <h2>Report Options</h2>
          <p>Generate a comprehensive report of this patient's record including:</p>
          <ul>
            <li>Demographics and contact information</li>
            <li>Clinical history and conditions</li>
            <li>Consultations and appointments</li>
            <li>Prescriptions and medications</li>
            <li>Lab results and vital signs</li>
            <li>Allergies and immunisations</li>
            <li>Audit trail</li>
          </ul>
          <p>Reports can be exported in multiple formats: JSON, FHIR R4, CSV, or XML.</p>
          <button
            className="btn-primary"
            onClick={() => setShowBuilder(true)}
          >
            Generate Report
          </button>
        </div>
      )}
    </div>
  )
}
